"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BarGauge = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = require("styled-components");

var _index = require("../index");

var _colors = require("../../utils/colors");

var _BarGauge = require("./BarGauge.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var BarGauge = function BarGauge(props) {
  var heading = props.heading,
      value = props.value,
      maxValue = props.maxValue,
      description = props.description,
      unit = props.unit,
      theme = props.theme,
      leftLabel = props.leftLabel,
      rightLabel = props.rightLabel;
  var barPercentage = Math.round(value / maxValue * 100);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_BarGauge.StyledLabelsContainer, null, _react.default.createElement(_BarGauge.StyledHeadingText, {
    marginRight: "10px",
    level: "h6",
    fontWeight: "500"
  }, heading), value && description.length > 0 && _react.default.createElement(_BarGauge.StyledHeadingText, {
    marginRight: "5px",
    level: "h6"
  }, value.toString()), unit.length > 0 && _react.default.createElement(_index.Heading, {
    color: theme.colors.primaryFont,
    level: "h6"
  }, "".concat(unit)), description.length > 0 && _react.default.createElement(_index.Text, {
    color: (0, _colors.getRGBOpacity)(theme.colors.primaryFont, 0.5)
  }, "".concat(description, " ").concat(maxValue))), _react.default.createElement(_BarGauge.StyledGaugeBar, null, _react.default.createElement(_BarGauge.StyledGaugeBarIndicator, {
    value: barPercentage
  })), _react.default.createElement(_BarGauge.StyledGaugeLabel, {
    level: "small"
  }, leftLabel), _react.default.createElement(_BarGauge.StyledGaugeLabel, {
    level: "small",
    position: "right"
  }, rightLabel));
};

var BarGaugeWrapper = (0, _styledComponents.withTheme)(BarGauge);
exports.BarGauge = BarGaugeWrapper;
BarGauge.defaultProps = {
  maxValue: 100,
  description: '',
  unit: '',
  leftLabel: '',
  rightLabel: '',
  theme: {}
};
BarGauge.propTypes = {
  heading: _propTypes.default.string.isRequired,
  value: _propTypes.default.number.isRequired,
  maxValue: _propTypes.default.number,
  description: _propTypes.default.string,
  unit: _propTypes.default.string,
  leftLabel: _propTypes.default.string,
  rightLabel: _propTypes.default.string,
  theme: _propTypes.default.any
};